import { useQuery } from '@tanstack/react-query';
import { getApiV1Outcrops } from '../api/generated';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchOutcropData = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.outcrops(),
    queryFn: () => getApiV1Outcrops(),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });

  return query;
};
